import {createFileRoute, redirect} from '@tanstack/react-router';
import {USER_HOME} from '@/shared/routing/paths';

function RedirectToHome() {
  return null;
}

export const Route = createFileRoute('/(practitioner)/practitioner/patient-payment-orders')({
  component: RedirectToHome,
  beforeLoad: function () {
    throw redirect({to: USER_HOME, replace: true});
  }
});
